import request from '@/utils/request'
/**
 * 部门管理API
 *
 * @author Jay Qing
 * @since 2021/06/07
 */

/**
 * 基础接口
 *
 * @type {string}
 */
export const BASE_URL = '/system/department'

/**
 * 树形部门信息查询接口
 *
 * @type {string}
 */
export const TREE_URL = BASE_URL + '/tree'

/**
 * 树形部门信息查询
 *
 * @param query 查询条件
 * @return {Promise}
 */
export function tree(query: any) {
  return request({
    url: TREE_URL,
    method: 'get',
    params: query
  })
}

/**
 * 查询根节点部门信息查询
 *
 * @param query 查询条件
 * @return {Promise}
 */
export function listRoots(query: any) {
  return request({
    url: `${BASE_URL}/list/root`,
    method: 'get',
    params: query
  })
}

/**
 * 查询子节点部门信息查询
 *
 * @param query 查询条件
 * @return {Promise}
 */
export function listChildren(query: any) {
  return request({
    url: `${BASE_URL}/list/children`,
    method: 'get',
    params: query
  })
}

/**
 * 查询指定ID的数据
 *
 * @param id ID
 * @returns {Promise}
 */
export function get(id: any) {
  return request({
    url: BASE_URL + '/get/' + id,
    method: 'get'
  })
}

/**
 * 保存数据
 *
 * @param data 数据
 * @returns {Promise}
 */
export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

/**
 * 更新数据
 *
 * @param data 数据
 * @returns {Promise}
 */
export function update(data: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: data
  })
}

/**
 * 删除数据
 *
 * @param idList ID数组
 * @returns {Promise}
 */
export function remove(idList: any) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: idList
  })
}
